export const ryftBusinessTypeLabels: Record<string, string> = {
  Corporation: "Corporation",
  GovernmentEntity: "Government entity",
  Charity: "Charity",
  LimitedPartnership: "Limited partnership",
  PrivateCompany: "Private company",
  PublicCompany: "Public company",
};

const verificationFieldLabels: Record<string, string> = {
  name: "Business name",
  type: "Business type",
  registrationNumber: "Registration number",
  registeredAddress: "Registered address",
  contactEmail: "Contact email",
  persons: "Director details",
  firstName: "First name",
  middleNames: "Middle name",
  lastName: "Last name",
  email: "Email",
  dateOfBirth: "Date of birth",
  countryOfBirth: "Country of birth",
  nationalities: "Nationalities",
  gender: "Gender",
  address: "Address",
  lineOne: "Address line",
  city: "City",
  country: "Country",
  postalCode: "Postal code",
  phoneNumber: "Phone number",
};

export const verificationFieldLabel = (name: string) => {
  const field = name.split(".").at(-1) ?? name;
  return verificationFieldLabels[field] ?? field;
};
